import { cellValue } from 'commonComponents/MaterialTable';
import { TableRow } from 'commonComponents/TableRow';

import { ProductConfiguration as ConfigurationDetailsType } from 'api/productConfigurations';
import { getNumberOfMacAddresses, isRuntimeFeature } from 'licenses/utils';

import { durationOrUnlimited } from './durationUnits';

const ROW_DATA_MAPPER = [
    {
        title: 'Name',
        accessor: 'name',
    },
    {
        title: 'Part No.',
        accessor: 'partNo',
    },
    {
        title: 'Validity',
        accessor: details => durationOrUnlimited(details.validity, details.validityUnit),
    },
    {
        title: 'Support Period',
        accessor: details => durationOrUnlimited(details.supportValidity, details.supportValidityUnit),
    },
    {
        title: 'Maximum Number of Activations',
        accessor: details => (details.maximumActivations ? details.maximumActivations : 'unlimited'),
    },
    {
        title: 'Hardware Binding',
        accessor: details => details.product?.hardwareBindings?.find(({ id }) => id === details?.hardwareBinding)?.type,
    },
    {
        title: 'Maximum Number of Mac Addresses',
        accessor: details => getNumberOfMacAddresses(details),
    },
    {
        title: 'Maximum Number of Concurrent Users',
        accessor: details => details.maxNumberOfConcurrentUsers ?? 'unlimited',
        hide: details => !details.product.use_no_of_concurrent_users,
    },
    {
        title: 'Serial Number',
        accessor: 'hasSerialNumber',
    },
    {
        title: 'License Can Sign Files',
        accessor: 'can_sign_files',
        hide: details => {
            return (
                !details.product.can_sign_files ||
                !details.product?.hardwareBindings?.find(({ id }) => id === details?.hardwareBinding)?.licenseGenerator
                    ?.can_sign_files
            );
        },
    },
    {
        title: 'Features',
        accessor: details =>
            details.features
                ?.filter(f => !isRuntimeFeature(f))
                .map(f => f.name)
                .join(', ') || '',
    },
    {
        title: 'Application Names',
        accessor: details => details.runtimeFeatures?.map(f => f.name).join(', ') || '',
        hide: details => !details.product.is_application,
    },
    {
        title: 'Max Version',
        accessor: 'max_version',
        hide: details => !details.product.has_max_version,
    },
    { title: 'Comment', accessor: 'comment' },
    {
        title: 'Additional License Data',
        accessor: 'additionalLicenseData',
        hide: details => !details.product.allow_additional_license_data,
    },
];

type ConfigurationDetailsRowsProps = {
    configuration: ConfigurationDetailsType;
};

export function ConfigurationDetailsRows({ configuration }: ConfigurationDetailsRowsProps) {
    return ROW_DATA_MAPPER.map(rowData => {
        const value = cellValue(configuration, rowData);
        return <TableRow key={`${rowData.title}: ${value}`} title={rowData.title} value={value} />;
    });
}
